import React from 'react';
import styled from 'styled-components';

const shouldForwardProp = prop => !['active'].includes(prop);

const TabHeaderStyled = styled.div`
  display: flex;
  gap: 4px;
`;

const Tab = styled.div.withConfig({ shouldForwardProp })`
  border-radius: 10px 10px 0px 0px;
  padding: 8px 16px;

  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;

  ${props => {
    if (props.active) {
      return `
        border-top: 1px solid var(--Primary-400);
        border-left: 1px solid var(--Primary-400);
        border-right: 1px solid var(--Primary-400);
        border-bottom: 1px solid var(--GrayScale-0);
        margin-bottom: -1px;
        color: var(--Primary-900);
        background-color: var(--GrayScale-0);
        position: relative;
        z-index: 1;
      `;
    } else {
      return `
        // border-bottom: 1px solid var(--Primary-400);
        background: var(--GrayScale-100);
        color: var(--GrayScale-600);
      `;
    }
  }};
`;

const TabContentPanel = ({ tabs = [], activeTab, onTabChange, children }) => {
  return (
    <div className="tab-content-panel">
      {/* 탭 헤더 영역 */}
      <TabHeaderStyled>
        {tabs.map((tab, index) => (
          <Tab key={index} onClick={() => onTabChange(tab.value)} active={activeTab === tab.value}>
            {tab.label}
          </Tab>
        ))}
      </TabHeaderStyled>

      {/* 컨텐츠 영역 */}
      <div className="tab-content">{children}</div>
    </div>
  );
};

export default TabContentPanel;
